import Main from "../views/Layouts/Main";
import UnderMaintenance from "../views/Layouts/UnderMaintenance";
import Users from "../views/Users";
import AddExpense from "../views/AddNewExpense";
import Currency from "../views/Currency";
import Dashboard from "../views/Dashboard";
import Departments from "../views/Departments";
import ExpenseCalendarControl from "../views/ExpenseCalendarControl";
import ExpenseCode from "../views/ExpenseCode";
import ListOfExpense from "../views/ListOfExpense";
import DraftExpenseRequest from "../views/ListOfExpense/draftExpenseRequest";

import Notifications from "../views/Notifications";
import PendingRequests from "../views/PendingRequests";
import Permissions from "../views/Permissions";
import ProjectCode from "../views/ProjectCode";
import Roles from "../views/Roles";
import Settings from "../views/Settings";
import LogViewer from "../views/LogViewer";
import Vendors from "../views/Vendors";
import Designations from "../views/Designations";
import Locations from "../views/Locations";
import Diems from "../views/Diems";

export const componentMap = {
  "/dashboard": (
    <Main children={<Dashboard />} key_elem="1" nameLink="Dashboard" />
  ),
  "/add-expense": (
    <Main children={<AddExpense />} key_elem="2" nameLink="Add Expense" />
  ),
  "/list-of-expense": (
    <Main
      children={<ListOfExpense />}
      key_elem="3"
      nameLink="List of Expense"
    />
  ),
  "/list-of-expense/:id": (
    <Main
      children={<ListOfExpense />}
      key_elem={"4"}
      nameLink="Expense Listing Detail"
    />
  ),
  "/list-of-expense/draft/:id": (
    <Main
      children={<DraftExpenseRequest />}
      key_elem={"5"}
      nameLink="Draft Expense Request"
    />
  ),
  "/pending-requests": (
    <Main
      children={<PendingRequests />}
      key_elem="6"
      nameLink="Pending Requests"
    />
  ),
  "/pending-requests/:id": (
    <Main
      children={<PendingRequests />}
      key_elem={"7"}
      nameLink="Pending Request Detail"
    />
  ),
  "/expense-code": (
    <Main children={<ExpenseCode />} key_elem="8" nameLink="Expense Code" />
  ),
  "/project-code": (
    <Main children={<ProjectCode />} key_elem="9" nameLink="Project Code" />
  ),
  "/settings": (
    <Main children={<Settings />} key_elem="10" nameLink="Settings" />
  ),
  "/users": <Main children={<Users />} key_elem="11" nameLink="Users" />,
  "/permissions": (
    <Main children={<Permissions />} key_elem="12" nameLink="Permissions" />
  ),
  "/roles": <Main children={<Roles />} key_elem="13" nameLink="Roles" />,
  "/departments": (
    <Main children={<Departments />} key_elem="14" nameLink="Departments" />
  ),
  "/designations": (
    <Main children={<Designations />} key_elem="15" nameLink="Designations" />
  ),
  "/notifications": (
    <Main children={<Notifications />} key_elem="16" nameLink="Notifications" />
  ),
  "/notifications/:id": (
    <Main
      children={<Notifications />}
      key_elem={"17"}
      nameLink="Notification Detail"
    />
  ),
  "/currency": (
    <Main children={<Currency />} key_elem="18" nameLink="Currency" />
  ),
  "/expense-calendar-control": (
    <Main
      children={<ExpenseCalendarControl />}
      key_elem="19"
      nameLink="Expense Calendar Control"
    />
  ),
  "/vendors": <Main children={<Vendors />} key_elem="20" nameLink="Vendors" />,
  "/diems": <Main children={<Diems />} key_elem="21" nameLink="Diems" />,
  "/locations": (
    <Main children={<Locations />} key_elem="22" nameLink="Locations" />
  ),
  noRoute: "/404",
  "/underMaintenance": <UnderMaintenance />,
  "/logs": <LogViewer />,
};

export const roles = {
  SUPERADMIN: [
    "/dashboard",
    "/diems",
    "/departments",
    "/designations",
    "/locations",
    "/vendors",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/expense-code",
    "/project-code",
    "/permissions",
    "/roles",
    "/users",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
    "/currency",
    "/settings",
    "/expense-calendar-control",
  ],
  ADMIN: [
    "/dashboard",
    "/diems",
    "/departments",
    "/vendors",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
    "/project-code",
    "/expense-code",
    "/currency",
    "/expense-calendar-control",
  ],
  APPROVER: [
    "/dashboard",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/pending-requests",
    "/pending-requests/:id",
    "/project-code",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
  ],
  EMPLOYEE: [
    "/dashboard",
    "/add-expense",
    "/list-of-expense",
    "/list-of-expense/:id",
    "/list-of-expense/draft/:id",
    "/project-code",
    "/notifications",
    "/notifications/:id",
    "/notificationUnReadCount",
  ],
};
